//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "vuelidate/lib/validators";
import AQInput from "@/components/Generics/AQInput/AQInput";

export default {
    name: "SetLabel",
    components: {
        AQInput
    },
    props: {
        readonly: {
            type: Boolean
        },
        value: String,
        maxlength: {
            type: Number
        }
    },
    data() {
        return {
            labelValue: ""
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.labelValue = newValue && newValue !== this.$t("setLabel.untitledPlugin") ? newValue : "";
            },
            immediate: true
        }
    },
    validations: {
        labelValue: {
            required
        }
    },
    methods: {
        setLabelValue(v) {
            this.$emit("input", v);
        },
        inputBlur() {
            if (!this.labelValue) {
                this.labelValue = this.$t("setLabel.untitledConnector");
                this.$emit("input", this.labelValue);
            }
        }
    }
};
